import React from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import type { OigEntitlementSnapshot } from "@services/OIGGService";

export type OigCheckQuotaBarProps = {
  snapshot: OigEntitlementSnapshot | null;
  exhausted: boolean;
  onBuyMore: () => void;
};

export default function OigCheckQuotaBar({
  snapshot,
  exhausted,
  onBuyMore,
}: OigCheckQuotaBarProps) {
  if (!snapshot) {
    return null;
  }
  return (
    <Box data-testid="oig-check-quota-bar" sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography
        data-testid="oig-check-quota-chip"
        sx={{
          fontFamily: "Rethink Sans, sans-serif",
          fontSize: "13px",
          color: exhausted ? "#b45309" : "#155e75",
          fontWeight: 600,
        }}
      >
        Used {snapshot.used} / {snapshot.limit} this month
      </Typography>
      {snapshot.low_checks_threshold_reached && !exhausted ? (
        <Alert
          severity="warning"
          data-testid="oig-check-quota-low"
          action={
            <Button color="inherit" size="small" onClick={onBuyMore}>
              Buy checks
            </Button>
          }
        >
          You have used 85% or more of this month&apos;s company-wide exclusion-check
          pool. Buy an add-on block to keep screening.
        </Alert>
      ) : null}
      {exhausted ? (
        <Alert
          severity="error"
          data-testid="oig-check-quota-exhausted"
          action={
            <Button color="inherit" size="small" onClick={onBuyMore}>
              Buy checks
            </Button>
          }
        >
          Monthly exclusion-check allowance is exhausted. Purchase a block to continue.
        </Alert>
      ) : null}
    </Box>
  );
}
